<div
	class="form-group"
	[formGroup]="OBJ_form_group"
	[class.has-error]="isInvalid()">
	<ng-template #tooltipTemplate><div [innerHtml]="getHint()|translate"></div></ng-template>
	<label class="col-lg-2 control-label" [ngClass]="{'tgi-new': isNew()}">{{getLabelName()|translate}}
		<i *ngIf="getHint()" class="fa fa-info-circle tig-tooltip-icon"
		   [tooltip]="tooltipTemplate"
		   placement="top"
		   triggers="click"
		   containerClass="tig-tooltip"
		   delay="50"></i>
		<span *ngIf="isRequired()" class="tgi-asterisk"> *</span></label>
	<div class="col-lg-8">
		<input
			title="{{getHint()|translate}}"
			class="form-control"
			[formControlName]="OBJ_field_config.name"
			[placeholder]="getLabelName()|translate"
			[ngxTimepicker]="picker"
			[format]=24
			[disabled]="OBJ_field_config?.readonly"
			(change)="checkClearTime($event)"
		>
		<ngx-material-timepicker
			#picker
			[enableKeyboardInput]=true
			[minutesGap]="OBJ_field_config?.steps.minute"
			(timeSet)="setTime($event)"
		>
		</ngx-material-timepicker>
		<div class="tig-hint" *ngIf="OBJ_field_config.note">
			<span>{{ OBJ_field_config.note|translate}}</span>
		</div>
		<tig-form-error [OBJ_form_control]="getFormControl()"></tig-form-error>
	</div>
</div>
